<template>
  <v-layout>
    <v-col v-if="HashTag.isForm" cols :sm="6" class="pa-0">
      <v-form v-model="HashTag.isValid" ref="form">
        <v-card flat class="pt-5">
          <v-layout align-center class="px-3">
            <h2>{{ $t("menu.hashtag") }}</h2>
            <v-spacer></v-spacer>
            <v-icon @click="_fnReset()" color="primary"> mdi-close </v-icon>
          </v-layout>
          <v-card-text>
            <v-row>
              <v-col cols :sm="12" class="py-0">
                <v-text-field
                  color="primary"
                  :rules="[Rules.required]"
                  v-model="HashTag.obj.name"
                >
                  <template #label>
                    {{ $t(`table.name`) }}
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="12" class="py-0">
                <v-text-field
                  color="primary"
                  type="number"
                  :rules="[Rules.required, Rules.number]"
                  v-model="HashTag.obj.priority"
                >
                  <template #label>
                    {{ $t(`table.priority`) }}
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="12" class="pt-3">
                <v-checkbox
                  color="primary"
                  :label="$t(`table.trend`)"
                  v-model="HashTag.obj.isTrend"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-4">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="!HashTag.isValid"
              @click="HashTag.isCreate ? _fnCreate() : _fnUpdate()"
              >{{ HashTag.isCreate ? $t(`table.create`) : $t(`table.update`) }}
            </v-btn>
            <v-btn outlined color="primary" @click="_fnReset()">
              {{ $t(`table.cancel`) }}
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>

    <v-dialog
      v-if="HashTag.isDelete"
      v-model="HashTag.isDelete"
      persistent
      scrollable
      max-width="500"
    >
      <v-card>
        <v-card-title dense class="headline primary" />
        <v-card-text class="pt-2">
          {{ $t(`table.deleteMess`) }}
          <b>{{ HashTag.obj.name }}</b>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="_fnDelete()">
            {{ $t(`table.delete`) }}
          </v-btn>
          <v-btn outlined color="primary" @click="_fnReset()">
            {{ $t(`table.cancel`) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    model: "HashTag",
  }),
  watch: {
    "HashTag.obj.name": function () {
      if (this[this.model].obj.name) {
        this[this.model].obj = {
          ...this[this.model].obj,
          name: this[this.model].obj.name.replace(/\s/gi, ""),
        };
      }
    },
  },
  methods: {
    _fnReset() {
      if (this.$refs.form) this.$refs.form.reset();
      this.fnResetFlagView(this.model);
    },
    _fnReFresh() {
      this._fnReset();
      this[this.model].isRefresh = true;
    },
    async _fnCreate() {
      const { code } = await this.fnPost({
        url: `/v1/admin/hashtag`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
    async _fnUpdate() {
      const { code } = await this.fnPut({
        url: `/v1/admin/hashtag/${this[this.model].obj.id}`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
    async _fnDelete() {
      const { code } = await this.fnDelete({
        url: `/v1/admin/hashtag/${this[this.model].obj.id}`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
  },
};
</script>
